import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';

import SigninSignupForm from '@/js/components/www.iichi.com/pages/signin-signup/SigninSignupForm.vue';

document.addEventListener('DOMContentLoaded', () => {
  const signinSignupFormEl = document.querySelector('signin-signup-form') as HTMLElement;
  createApp({
    render: () =>
      h(SigninSignupForm, {
        modelValue: signinSignupFormEl.dataset.modelValue,
      }),
  }).mount(signinSignupFormEl);
});
